import { AnalyticsBrowser } from '@segment/analytics-next'
import { MARTECH_ENABLED_ENV, shouldSuppressMartech } from '@repo/martech-guard'
import type { App, Plugin } from 'vue'
import { type AnalyticsClient, setSegmentClient } from './analyticsClients'

export type SegmentOptions = {
  writeKey: string
}

export const segmentPlugin: Plugin = {
  async install(_: App, { writeKey }: SegmentOptions): Promise<void> {
    setSegmentClient(undefined)

    if (!writeKey) return

    // Skip loading Segment on local dev — set VITE_MARTECH_ENABLED=true in .env to test locally.
    if (shouldSuppressMartech({
      isLocalDevServer: import.meta.env.DEV,
      env: { [MARTECH_ENABLED_ENV]: import.meta.env.VITE_MARTECH_ENABLED },
    })) {
      return
    }

    try {
      const instance = AnalyticsBrowser.load({ writeKey })

      instance.catch(() => {
        console.error('Error loading segment')
        setSegmentClient(undefined)
      })

      setSegmentClient(instance as AnalyticsClient, instance)
    } catch (err) {
      console.error('Error loading segment: ', err)
    }
  },
}
